/**
 * **Die USt-IdNr. wird geprüft, bevor sie gespeichert wird** (08.10.2026).
 *
 * Bis zu diesem Tag stand das Feld frei: Ein Kunde mit der USt-IdNr.
 * „gfggffgffg" ließ sich anlegen, und erst der Kundenabgleich mit Lexware
 * Office scheiterte an ihm — alle fünf Minuten, mit
 * `lexware.vat_registration_id_unknown_country_code`, und ohne dass an der
 * Maske je etwas zu sehen war. Luca: *„fix mal, dass ich das gar nicht
 * speichern kann beim kunden … das feld muss immer abgefangen werden."*
 *
 * Geprüft wird die **Form**, nicht ob es die Nummer gibt — das kann nur das
 * Bundeszentralamt (BZSt/VIES), und eine Rückfrage dort gehört nicht in ein
 * Speichern. Die Form genügt, damit Lexware Office den Kontakt annimmt, und
 * sie fängt jeden Tippfehler, der Buchstaben und Ziffern vertauscht.
 *
 * **Nur die EU und Nordirland** (`XI`): Das sind die Länder, deren Nummern
 * auf einer Rechnung als USt-IdNr. gelten. Die Schweiz (`CHE…`) oder
 * Norwegen haben eine eigene Kennung, die Lexware unter diesem Feld nicht
 * führt — ob es sie annimmt, ist nicht geprüft. Bis dahin gilt: lieber leer
 * als drüben abgewiesen.
 */
/**
 * Was nach dem Länderkürzel stehen muss — die Muster der EU-Kommission
 * (VIES), ohne Prüfziffer. Griechenland heißt hier `EL`, nicht `GR`.
 */
const MUSTER = {
    AT: /^U\d{8}$/,
    BE: /^[01]\d{9}$/,
    BG: /^\d{9,10}$/,
    CY: /^\d{8}[A-Z]$/,
    CZ: /^\d{8,10}$/,
    DE: /^\d{9}$/,
    DK: /^\d{8}$/,
    EE: /^\d{9}$/,
    EL: /^\d{9}$/,
    ES: /^[A-Z0-9]\d{7}[A-Z0-9]$/,
    FI: /^\d{8}$/,
    FR: /^[A-Z0-9]{2}\d{9}$/,
    HR: /^\d{11}$/,
    HU: /^\d{8}$/,
    IE: /^\d[A-Z0-9+*]\d{5}[A-Z]{1,2}$/,
    IT: /^\d{11}$/,
    LT: /^(?:\d{9}|\d{12})$/,
    LU: /^\d{8}$/,
    LV: /^\d{11}$/,
    MT: /^\d{8}$/,
    NL: /^\d{9}B\d{2}$/,
    PL: /^\d{10}$/,
    PT: /^\d{9}$/,
    RO: /^\d{2,10}$/,
    SE: /^\d{12}$/,
    SI: /^\d{8}$/,
    SK: /^\d{10}$/,
    XI: /^(?:\d{9}|\d{12}|GD\d{3}|HA\d{3})$/,
};
/** Die Länderkürzel, die als USt-IdNr. angenommen werden. */
export const UST_ID_LAENDER = Object.keys(MUSTER);
/**
 * Die Schreibweise, in der gespeichert wird: groß, ohne Leerzeichen, Punkte,
 * Binde- und Schrägstriche. „de 123 456 789" und „DE-123.456.789" sind
 * dieselbe Nummer, und Lexware Office will sie am Stück.
 */
export function ustIdNormalisieren(roh) {
    return roh.toUpperCase().replace(/[\s.\-/]/g, '');
}
/** Prüft eine USt-IdNr. Leer ist kein Fehler — das entscheidet die Pflichtfeldregel. */
export function ustIdPruefen(roh) {
    const wert = ustIdNormalisieren(roh);
    const land = wert.slice(0, 2);
    const muster = /^[A-Z]{2}$/.test(land) ? MUSTER[land] : undefined;
    if (!muster)
        return { ok: false, grund: 'land', land: /^[A-Z]{2}$/.test(land) ? land : null };
    if (!muster.test(wert.slice(2)))
        return { ok: false, grund: 'format', land };
    return { ok: true, wert };
}
//# sourceMappingURL=ustid.js.map